import { ACCOUNT_ACTION } from '../../constants/actions'

const generateKYCSession = () => ({
  type: ACCOUNT_ACTION.GENERATE_KYC_SESSION
})

const changeKYCState = (property, value) => ({
  type: ACCOUNT_ACTION.CHANGE_KYC_STATE,
  payload: {
    property,
    value
  }
})

export { generateKYCSession, changeKYCState }
